import { useSearchParams as useSearchParamsRRD } from "react-router";

export function useSearchParams() {
	const [searchParams, setSearchParamsRRD] = useSearchParamsRRD();

	const setSearchParams = (newParams: Record<string, string>) => {
		const merged = new URLSearchParams(searchParams);

		Object.entries(newParams).forEach(([key, value]) => {
			if (value) {
				merged.set(key, value);
			} else {
				merged.delete(key);
			}
		});

		setSearchParamsRRD(merged);
	};

	const cleanParam = (key: string) => {
		const merged = new URLSearchParams(searchParams);

		merged.delete(key);
		setSearchParamsRRD(merged);
	};

	return [searchParams, setSearchParams, cleanParam] as const;
}
